<div class="main-content table-page table-page--compact fise-applications-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Gestión de Aplicaciones FISE</h1>
        <p>Seleccione un servidor y administre aplicaciones y usuarios asociados en una sola vista.</p>
      </div>
    </section>

    <section class="table-page__card fise-matrix__selector-card">
      <div class="fise-matrix__panel-head fise-matrix__panel-head--selector">
        <div class="fise-matrix__panel-copy">
          <span class="fise-matrix__panel-step">Paso 1</span>
          <h2>Seleccionar servidor</h2>
          <p>El servidor elegido define las aplicaciones y usuarios que se mostrarán en los paneles inferiores.</p>
        </div>
      </div>

      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Servidor</mat-label>
              <mat-select
                name="select-servidor"
                [ngModel]="servidorSelect"
                [compareWith]="compareServidores"
                (ngModelChange)="onServidorSelection($event)">
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="servidorCtrl"
                    placeholderLabel="Ingresar IP"
                    noEntriesFoundLabel="No existe servidor">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let item of listaServidor" [value]="item">
                  {{ item.ip }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--wide fise-matrix__server-summary">
            <div class="fise-matrix__selection" *ngIf="servidorSelect?.id_Servidor; else serverSummaryPlaceholder">
              <div>
                <span class="fise-matrix__selection-label">IP</span>
                <strong>{{ servidorSelect.ip }}</strong>
              </div>
              <div>
                <span class="fise-matrix__selection-label">Sistema operativo</span>
                <strong>{{ servidorSelect.so || 'Sin definir' }}</strong>
              </div>
              <div>
                <span class="fise-matrix__selection-label">Tipo</span>
                <strong>{{ servidorSelect.tipoServidor || 'Sin definir' }}</strong>
              </div>
              <div>
                <span class="fise-matrix__selection-label">Ubicación</span>
                <strong>{{ servidorSelect.ubicacion || 'Sin definir' }}</strong>
              </div>
            </div>

            <ng-template #serverSummaryPlaceholder>
              <div class="fise-matrix__selection fise-matrix__selection--placeholder">
                <i class="material-icons">touch_app</i>
                <span>Seleccione un servidor para habilitar la administración de aplicaciones y usuarios.</span>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </section>

    <div class="fise-matrix__grid">
      <section class="table-page__card fise-matrix__panel">
        <div class="fise-matrix__panel-head">
          <div class="fise-matrix__panel-copy">
            <span class="fise-matrix__panel-step">Paso 2</span>
            <h2>Aplicaciones</h2>
            <p *ngIf="servidorSelect?.ip; else appsPanelPlaceholder">Servidor seleccionado: {{ servidorSelect.ip }}</p>
            <ng-template #appsPanelPlaceholder>
              <p>Seleccione un servidor para consultar sus aplicaciones.</p>
            </ng-template>
          </div>

          <button
            type="button"
            mat-raised-button
            class="btn table-page__primary-btn"
            [disabled]="!servidorSelect?.id_Servidor"
            (click)="onClicMostrarModalAplicacion(null)">
            <i class="material-icons">add</i>
            <span>Agregar App</span>
          </button>
        </div>

        <div class="table-page__toolbar">
          <mat-form-field appearance="outline" class="table-page__search-field">
            <mat-label>Buscar aplicación</mat-label>
            <input
              aria-label="Buscar aplicación"
              matInput
              type="text"
              id="nombreAplicacion"
              name="nombreAplicacion"
              maxlength="20"
              soloLetraEspacioNumeroAcento
              [(ngModel)]="filtroAplicacion"
              (ngModelChange)="onFiltroAplicacionChange()" />
          </mat-form-field>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="listaAp.length > 0; else aplicacionesEmptyState">
            <thead>
              <tr>
                <th>Aplicación</th>
                <th>Versión</th>
                <th>Descripción</th>
                <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let aplicacionBean of listaAp"
                class="is-clickable"
                [class.is-selected]="aplicacionSelect?.id === aplicacionBean.id"
                (click)="onClicMostrarUsuarioxApp(aplicacionBean)"
                (keydown.enter)="$event.target === $event.currentTarget ? onClicMostrarUsuarioxApp(aplicacionBean) : null">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ aplicacionBean.idTipo }}</strong>
                    <span class="table-page__subtext">{{ aplicacionBean.ipServidor || servidorSelect.ip }}</span>
                  </div>
                </td>
                <td>{{ aplicacionBean.version || 'Sin definir' }}</td>
                <td>{{ aplicacionBean.descripcion || 'Sin descripción' }}</td>
                <td class="table-page__actions table-page__actions--multi">
                  <div class="table-page__action-group">
                    <button
                      type="button"
                      class="table-page__action-btn"
                      (click)="$event.stopPropagation(); onClicMostrarModalAplicacion(aplicacionBean)"
                      matTooltip="Editar aplicación">
                      <i class="material-icons">edit</i>
                    </button>
                    <button
                      type="button"
                      class="table-page__action-btn table-page__action-btn--danger"
                      (click)="$event.stopPropagation(); onClicBorrarApp(aplicacionBean)"
                      matTooltip="Eliminar aplicación">
                      <i class="material-icons">delete</i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <ng-template #aplicacionesEmptyState>
            <div class="table-page__empty" *ngIf="!loadingAplicaciones; else aplicacionesLoadingState">
              <i class="material-icons">apps</i>
              <strong>{{ getAplicacionEmptyTitle() }}</strong>
              <span>{{ getAplicacionEmptyMessage() }}</span>
            </div>
          </ng-template>

          <ng-template #aplicacionesLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando aplicaciones...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showAppsPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ appsRangeEnd }} de {{ totalRegAplicacion }} aplicaciones</span>
            <span>Página {{ currentAppsPage }} de {{ appsTotalPages || 1 }}</span>
            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="appsPageSize" (ngModelChange)="onAppsPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>

          <div class="table-page__pager" *ngIf="appsTotalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstAppsPage()" [disabled]="currentAppsPage === 1">Inicio</button>
            <button type="button" class="table-page__pager-link" (click)="previousAppsPage()" [disabled]="currentAppsPage === 1">Anterior</button>

            <ng-container *ngFor="let item of getAppsPaginationItems()">
              <button
                *ngIf="isPageNumber(item); else aplicacionesPagerEllipsis"
                type="button"
                class="table-page__pager-page"
                [class.is-current]="item === currentAppsPage"
                (click)="onAppsPageChange(item)">
                {{ item }}
              </button>

              <ng-template #aplicacionesPagerEllipsis>
                <span class="table-page__pager-ellipsis">...</span>
              </ng-template>
            </ng-container>

            <button type="button" class="table-page__pager-link" (click)="nextAppsPage()" [disabled]="currentAppsPage === appsTotalPages">Siguiente</button>
            <button type="button" class="table-page__pager-link" (click)="lastAppsPage()" [disabled]="currentAppsPage === appsTotalPages">Último</button>
          </div>
        </div>
      </section>

      <section class="table-page__card fise-matrix__panel">
        <div class="fise-matrix__panel-head">
          <div class="fise-matrix__panel-copy">
            <span class="fise-matrix__panel-step">Paso 3</span>
            <h2>Usuarios</h2>
            <p *ngIf="aplicacionSelect?.idTipo; else usuariosPanelPlaceholder">Aplicación seleccionada: {{ aplicacionSelect.idTipo }}</p>
            <ng-template #usuariosPanelPlaceholder>
              <p>Seleccione una aplicación para consultar sus usuarios.</p>
            </ng-template>
          </div>

          <button
            type="button"
            mat-raised-button
            class="btn table-page__primary-btn"
            [disabled]="!aplicacionSelect?.id"
            (click)="OnClicMostrarModalUsuario(null)">
            <i class="material-icons">add</i>
            <span>Agregar Usuario</span>
          </button>
        </div>

        <div class="table-page__toolbar">
          <mat-form-field appearance="outline" class="table-page__search-field">
            <mat-label>Buscar usuario</mat-label>
            <input
              aria-label="Buscar usuario"
              matInput
              type="text"
              id="nombreUsuario"
              name="nombreUsuario"
              maxlength="40"
              soloLetraEspacioNumeroAcento
              [(ngModel)]="filtroUsuario"
              (ngModelChange)="onFiltroUsuarioChange()" />
          </mat-form-field>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="listaUs.length > 0; else usuariosEmptyState">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Tipo</th>
                <th>Descripción</th>
                <th>Credencial</th>
                <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let usuarioBean of listaUs">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ usuarioBean.usuario }}</strong>
                    <span class="table-page__subtext">ID: {{ usuarioBean.id }}</span>
                  </div>
                </td>
                <td>{{ usuarioBean.tipo_usuario || 'Sin definir' }}</td>
                <td>{{ usuarioBean.descripcion || 'Sin descripción' }}</td>
                <td>
                  <div class="table-page__action-group">
                    <span class="table-page__subtext">••••••••••</span>
                    <button
                      type="button"
                      class="table-page__action-btn"
                      #tooltip="matTooltip"
                      [matTooltip]="tooltipCopiarPass"
                      ngxClipboard
                      [cbContent]="usuarioBean.password"
                      (cbOnSuccess)="onClicCopiar()"
                      (click)="tooltip.show()">
                      <i class="material-icons">content_copy</i>
                    </button>
                  </div>
                </td>
                <td class="table-page__actions table-page__actions--multi">
                  <div class="table-page__action-group">
                    <button type="button" class="table-page__action-btn" (click)="OnClicMostrarModalUsuario(usuarioBean)" matTooltip="Editar usuario">
                      <i class="material-icons">edit</i>
                    </button>
                    <button type="button" class="table-page__action-btn table-page__action-btn--danger" (click)="onClicBorrarUsuario(usuarioBean)" matTooltip="Eliminar usuario">
                      <i class="material-icons">delete</i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <ng-template #usuariosEmptyState>
            <div class="table-page__empty" *ngIf="!loadingUsuarios; else usuariosLoadingState">
              <i class="material-icons">group</i>
              <strong>{{ getUsuariosEmptyTitle() }}</strong>
              <span>{{ getUsuariosEmptyMessage() }}</span>
            </div>
          </ng-template>

          <ng-template #usuariosLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando usuarios...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showUsersPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ usersRangeEnd }} de {{ totalRegUsuarios }} usuarios</span>
            <span>Página {{ currentUsersPage }} de {{ usersTotalPages || 1 }}</span>
            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="usersPageSize" (ngModelChange)="onUsersPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>

          <div class="table-page__pager" *ngIf="usersTotalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstUsersPage()" [disabled]="currentUsersPage === 1">Inicio</button>
            <button type="button" class="table-page__pager-link" (click)="previousUsersPage()" [disabled]="currentUsersPage === 1">Anterior</button>

            <ng-container *ngFor="let item of getUsersPaginationItems()">
              <button
                *ngIf="isPageNumber(item); else usuariosPagerEllipsis"
                type="button"
                class="table-page__pager-page"
                [class.is-current]="item === currentUsersPage"
                (click)="onUsersPageChange(item)">
                {{ item }}
              </button>

              <ng-template #usuariosPagerEllipsis>
                <span class="table-page__pager-ellipsis">...</span>
              </ng-template>
            </ng-container>

            <button type="button" class="table-page__pager-link" (click)="nextUsersPage()" [disabled]="currentUsersPage === usersTotalPages">Siguiente</button>
            <button type="button" class="table-page__pager-link" (click)="lastUsersPage()" [disabled]="currentUsersPage === usersTotalPages">Último</button>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
